import wrapper from 'wrapper';

const wsConfig = require('@bbc/news-vj-ws-config/config.json');

const basePath = 'https://a1.api.bbc.co.uk/hit.xiti?&col=1&from=p&ptag=js&p=idt::full_width::news.locusts.page&x1=[urn:bbc:idt:locusts_english]&x2=[responsive]&x3=[bbc_website]&x7=[article]&x8=[reverb-1.2.0]&';

const atiTracking = () => {
    const lang = wrapper.getConfig().language;
    const langConfig = wsConfig[lang];
    const queryString = {
        s: langConfig.AtiSiteIdLive,
        x4: langConfig.languageCode,
        x5: encodeURIComponent(window.location.href),
        x6: encodeURIComponent(document.referrer),
        x9: encodeURIComponent(document.title),
        s2: langConfig.AtiProducerId,
    };

    const trackingPixelPath = Object.keys(queryString).reduce((acc, key) => {
        return `${acc}${key}=${queryString[key]}&`;
    }, basePath);

    const pixelWrapper = wrapper.select('#ati_pixel');
    const pixelImage = document.createElement('img');
    pixelImage.src = trackingPixelPath;

    pixelWrapper.appendChild(pixelImage);
};

export default atiTracking;
